import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { SearchParams } from 'src/app/shared/models/searchParams';
import { ActivatedRoute } from '@angular/router';
import { ClientContract, PaymentPlanEnum } from 'src/app/shared/models/clients/clientContract';
import { PrintService } from 'src/app/core/services/print.service';

@Component({
  selector: 'app-client-contracts',
  templateUrl: './client-contracts.component.html',
  styleUrls: ['./client-contracts.component.scss']
})
export class ClientContractsComponent implements OnInit {
  public contracts: ClientContract[] = [];
  contract: ClientContract;
  public clientId = null;
  public searchParams = new SearchParams();
  modalRef: NgbModalRef;
  paymentPlanEnum = PaymentPlanEnum;

  @ViewChild('contractModal') contractModal;

  constructor(
    private modalService: NgbModal,
    private apiService: ClientsApiService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private printService: PrintService,

  ) {
    this.route.parent.data.subscribe(resolversData => {
      this.clientId = resolversData.client.id;
    });

  }

  ngOnInit(): void {
    this.loadContracts();
  }

  loadContracts() {
    this.spinner.show();
    this.apiService.getClientContracts(this.searchParams, this.clientId).subscribe(
      c => {
        this.spinner.hide();
        this.contracts = c.results;
      }
    )
  }

  onSearch(e: KeyboardEvent) {
    if (e.keyCode === 13) {
      this.searchParams.page = 1;
      this.searchParams.search = (e.target as HTMLInputElement).value;
      this.loadContracts();
    }
  }

  addNewContract() {
    this.contract = new ClientContract();
    this.contract.clientId = this.clientId;
    this.modalRef = this.modalService.open(this.contractModal, { centered: true, size: 'lg' });
  }

  editContract(contract: ClientContract) {
    this.contract = contract;
    this.modalRef = this.modalService.open(this.contractModal, { centered: true, size: 'lg' });
  }

  submitContract(contract: ClientContract) {
    let action = '';
    this.spinner.show();
    if (this.contracts.find(n => contract.id === n.id)) {
      this.apiService.updateClientContract(contract.clientId, contract).subscribe(
        c => {
          this.spinner.hide();
          action = 'updated';
          const i = this.contracts.findIndex((value, index, array) => value.id === c.id);
          this.contracts[i] = c;
        }
      )
    } else {
      this.apiService.createClientContract(this.clientId, contract).subscribe(
        c => {
          this.spinner.hide();
          action = 'created';
          this.contracts.push(c);
        }
      )
    }
    this.modalRef.close();
    this.toastr.success(`contract ${action}`, 'Success!');
  }

  print() {
    this.route.parent.data.subscribe(resolversData => {
      this.printService.data = { contracts: this.contracts, clientName: resolversData.client.fullName };
      this.printService.printDocument('client-contracts');
    });
  }

}